import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useClarity } from '../hooks/useClarity';

/**
 * Component that tracks page views with Microsoft Clarity
 * This component doesn't render anything, it just tracks page views
 */
const ClarityPageTracker: React.FC = () => {
  const location = useLocation();
  const { trackPageView } = useClarity();
  
  // Track page views when the location changes
  useEffect(() => {
    const pageName = location.pathname || '/';
    trackPageView(pageName);
  }, [location, trackPageView]);
  
  // This component doesn't render anything
  return null;
};

export default ClarityPageTracker;
